import { Add, Remove } from "@mui/icons-material";
import { Box, InputAdornment, TextField } from "@mui/material";
import { GetData } from "contexts/DataContext";
import React from "react";
import Repeatable from "react-repeatable";

export function DelayField(props) {
  const { dataObj, forceSetDataObj } = GetData();
  const [delay, setDelay] = React.useState(
    Number(dataObj?.sliderDelay || "15")
  );

  React.useEffect(() => {
    setDelay(Number(dataObj?.sliderDelay || "15"));
  }, [dataObj?.sliderDelay]);

  function changeDelay(add, save = false) {
    let currentDelay = delay;
    let newDelay = 0;
    if (add) {
      if (currentDelay >= 120) newDelay = currentDelay;
      else newDelay = currentDelay + 1;
    } else if (currentDelay > 5) {
      newDelay = currentDelay - 1;
    } else {
      newDelay = currentDelay;
    }
    setDelay(newDelay);
    save && forceSetDataObj(newDelay, "sliderDelay");
  }

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <TextField
        InputProps={{
          disabled: true,
          style: {
            // fontSize: dataObj?.deviceWidth?.isMobile
            //   ? "0.875rem"
            //   : "1rem",
          },
          startAdornment: (
            <InputAdornment
              position="start"
              onClick={(e) => {
                changeDelay(false, true);
              }}
            >
              <Repeatable
                onHold={() => {
                  changeDelay(false);
                  // Callback fired mutiple times while holding down.
                }}
                onHoldEnd={() => {
                  forceSetDataObj(delay, "sliderDelay");
                }}
              >
                <Remove />
              </Repeatable>
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment
              position="end"
              onClick={(e) => {
                changeDelay(true, true);
              }}
            >
              <Repeatable
                onHold={() => {
                  changeDelay(true);
                  // Callback fired mutiple times while holding down.
                }}
                onHoldEnd={() => {
                  forceSetDataObj(delay, "sliderDelay");
                }}
              >
                <Add />
              </Repeatable>
            </InputAdornment>
          ),
        }}
        id="input-delay"
        // fullWidth
        inputProps={{
          maxLength: 3,
          style: { textAlign: "center" },
        }}
        label={"Частота смены слайда"}
        mb={2}
        mt={2}
        name="delay"
        sx={{
          margin: "0.875rem 0",
          // width: "180px",
          textAlign: "center !important",
        }}
        type="text"
        value={delay ? delay + " cек." : "15 сек."}
        variant="standard"
      />
    </Box>
  );
}
